module.exports = __webpack_public_path__ + "officialStatic/img/news1.c8ac6b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/news1.png
// module id = fWeY
// module chunks = 0